jQuery(document).ready(() => {
  const faqs = $('.faq-question');
  faqs.each(function(index, faq) {
    $(faq).click(function() {
      const reponse = this.nextElementSibling;
      if (reponse.style.maxHeight) {
        $(this).removeClass('active');
        reponse.style.maxHeight = null;
      } else {
        $(this).addClass('active');
        reponse.style.maxHeight = reponse.scrollHeight + 'px';
      }
    });
  });
});
